<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <div class="dialog-content">
    <div class="top-content">
      @if ((data?.cartLineCount ?? 0) > 0) {
        <div class="notification notification-info">
          <mat-icon>information</mat-icon>
          <span class="text--black"> {{ 'confirmOrder.existingOrderLinesInCartWarning' | translate }}</span>
        </div>
      }
      <ng-container class="top-content">
        <mat-list data-test="confirm-order-order-lines-table" class="spacing--margin-negative-horizontal">
          @for (periodId of getUniquePeriodIds(); track periodId) {
            <h3 class="text-color--gray2" data-test="confirm-order-period-header">
              {{ formatPeriodHeader(periodId) }}
            </h3>
            @for (orderLine of getOrderLinesByPeriod(periodId); track orderLine.id) {
              <mat-list-item data-test="confirm-order-order-line-row">
                <mat-icon matListItemIcon> store</mat-icon>
                <span matListItemTitle>
                  {{ getCropAid(orderLine.cropAidId)?.name }}
                  {{ getCropAidCodeToDisplay(orderLine.cropAidId) }}
                </span>
                <span matListItemLine>
                  {{ orderLine.count }} x {{ getPackageAmount(orderLine.packageId) | agrNumber }}
                  {{ getPackageUnitOfMeasurement(orderLine.packageId) }}
                </span>
              </mat-list-item>
            }
          }
        </mat-list>
      </ng-container>
    </div>

    @if (showAmountWarning()) {
      <div class="notification notification-warning">
        <mat-icon>warning</mat-icon>
        <span class="text--black"> {{ 'confirmOrder.amountWarning' | translate }}</span>
      </div>
    }
  </div>
</agr-dialog>
